/**
 * 아이디 마스킹 처리
 * @param id 마스킹할 아이디
 * @returns 마스킹된 아이디 (예: kurly12***)
 * @note 정책: 이메일 형식인 경우, 이메일 아이디 부분만 마지막 3글자 마스킹 / 이메일 형식이 아닌 경우, 마지막 3글자 마스킹
 */
const maskId = (id: string | null | undefined): string => {
  if (!id) return '-';

  const MASK_LENGTH = 3;
  const MASK_CHARS = '*'.repeat(MASK_LENGTH);

  const maskLastChars = (str: string): string => {
    if (str.length <= MASK_LENGTH) {
      return str;
    }
    return str.slice(0, -MASK_LENGTH) + MASK_CHARS;
  };

  if (id.includes('@')) {
    const [localPart, domain] = id.split('@');
    return `${maskLastChars(localPart)}@${domain}`;
  }

  return maskLastChars(id);
};

export default maskId;
